/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 5
// module chunks = 1 2